"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("./styles/Toastify.scss");
const Toast_1 = tslib_1.__importDefault(require("./views/toast/Toast"));
const Toastify = ({ toastArray, deleteMessage }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: toastArray
            ? (0, jsx_runtime_1.jsx)("div", { id: 'global-toast-id', className: 'notification-container top-right', children: toastArray.map((el, index) => {
                    return ((0, jsx_runtime_1.jsx)(Toast_1.default, { index: index, toast: el, noAutoDelete: false, deleteToast: deleteMessage }, index));
                }) })
            : null }));
};
exports.default = Toastify;
